<template>
  <div class="results databoard">
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>大数据看板 </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="results-wrap">
      <div class="headtitle">定制政务RCEP平台大数据看板</div>
      <div class="s1">
        <div class="s1Wrap">
          <Row :gutter="0" type="flex">
            <Col span="5" class="p1">
              <div class="wrap">
                <div class="title">BI智能大数据分析</div>
                <div class="desc">根据实际的进出口贸易情况，系统提供贸易数据RCEP应用情况统计分析数据看板，帮助政府更加直观的了解本省进出口企业运用RCEP协议或其他自由贸易协定优惠关税的情况，为政府部门提供对企政策智能指导服务和政策规划的精准数据支撑。</div>
              </div>
            </Col>
            <Col span="19" class="p2">
              <div class="wrap">
                <img src="~@/assets/images/databoard/1.jpg" class="bg">
                <div class="title1">跨数据源整合</div>
                <div class="title2">可视化图表展示</div>
                <div class="title3">实时动态报表分析</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s2">
        <div class="title">多维度统计分析</div>
        <p>提高FTA利用率是个持续的过程，一方面各套FTA的协定税率需要５－２５年逐步降为零关税，一方面企业尤其中小企业需要一个学习的时间来了解如何应用。</p>
        <p>各地政府需要通过及时掌握企业的利用情况和遇到的困难来不断推出有针对性的公共服务，从而持续提高整个区域的FTA利用率。</p>
        <p>本系统通过精准统计特定省市或区域的FTA协定关税利用情况，以及优惠贸易往来情况，对特定产业、特定国别、特定FTA协定的利用情况可做综合研判，可为政府制定产业政策提供重要的参考数据。</p>
      </div>
      <div class="s3">
        <div class="title">支持各类可视化图表组合展示</div>
        <div class="list">
          <Row type="flex">
            <Col span="4"><img src="~@/assets/images/databoard/a1.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4"><img src="~@/assets/images/databoard/a2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4"><img src="~@/assets/images/databoard/a3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4"><img src="~@/assets/images/databoard/a4.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4"><img src="~@/assets/images/databoard/a5.png" alt=""></Col>
          </Row>
        </div>
      </div>
      <ZX></ZX>
    </div>
  </div>
</template>

<script>
import ZX from '@/components/layout/ZX'

export default {
  name: 'DataBoard',
  components: { ZX },
}
</script>

<style scoped>
.results{
  position: relative;
  padding: 15px 0 25px;
}
.results-wrap{
  width:1400px;
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: var(--contentPageMaxWidth);
}
.headtitle{
  font-size: 2.6rem;
  margin-top: 20px;
  margin-bottom: 70px;
  font-weight: bold;
  color: #333;
  text-align: center;
}
.s1 .wrap, .s2 .wrap{
  position: relative;
}
.s1 .p1{
  background-color: #0675b5;
}
.s1 .title, .s1 .title1, .s1 .title2, .s1 .title3{
  font-size: 16px;
  color: #f2a46f;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -36px;
  font-weight: bold;
  white-space: nowrap;
}
.s1 .title1{
  left: 0;
  transform: translateX(0);
  width: 30%;
}
.s1 .title2{
  left: 30%;
  transform: translateX(0);
  width: 40%;
}
.s1 .title3{
  left: 70%;
  transform: translateX(0);
  width: 30%;
}
.s1 .p2 .bg{
  width: 100%;
}
.s1 .p1 .desc {
  color: #fff;
  font-size: 14px;
  line-height: 26px;
  text-indent: 20px;
  padding: 40px;
  text-align: justify;
}
.s2, .s3{
  margin-top: 40px;
}
.s2{
  margin-top: 50px;
}
.s3{
  margin-bottom: 60px;
}
.s2 .title, .s3 .title{
  font-size: 16px;
  color: #f2a46f;
  font-weight: bold;
  margin-bottom: 10px;
}
.s2 p{
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  line-height: 24px;
  text-indent: 30px;
  text-align: justify;
}
.s3 .list{
  margin-top: 20px;
  padding: 0 20px;
}
.s3 .list img{
  width: 100%;
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .databoard .headtitle{
    font-size: 3rem;
  }
  .databoard .s1 .title, .databoard .s1 .title1, .databoard .s1 .title2, .databoard .s1 .title3{
    font-size: 18px;
  }
  .databoard .s1 .p1 .desc{
    font-size: 16px;
  }
  .databoard .s2 .title, .databoard .s3 .title{
    font-size: 18px;
  }
  .databoard .s2 p{
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/DataBoard.vue